const appRoutes=[
  {
    path: '/dashboard',
    name: 'CustomerDashboard',
    component: () => import('../views/Customer/CustomerDashboardView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/mail',
    name: 'CustomerMailWorkspace',
    redirect: '/mail/inbox',
    meta: { requiresCustomer: true }
  },
  {
    path: '/mail/:application(inbox|important|sent|drafts|archive|junk|spam|trash|calendar|tasks|billing|team)',
    name: 'CustomerMailApp',
    component: () => import('../views/Customer/CustomerMailAppView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/mail/:application(inbox|important|sent|drafts|archive|junk|spam|trash)/message/:messageId',
    name: 'CustomerMailMessage',
    component: () => import('../views/Customer/CustomerMailMessageView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/mail/billing/mpesa-checkout',
    name: 'CustomerMpesaCheckout',
    component: () => import('../views/Customer/Billing/CustomerMpesaCheckoutView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/mail/billing/documents/:documentId',
    name: 'CustomerBillingDocument',
    component: () => import('../views/Customer/Billing/BillingDocumentView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/mail/accounts/:mailboxId/manage',
    name: 'CustomerMailboxManage',
    component: () => import('../views/Customer/Accounts/MailAccountManageView.vue'),
    meta: { requiresCustomer: true, requiresCompanyAdmin: true }
  },
  {
    path: '/mail/accounts/:mailboxId/signatures',
    name: 'CustomerMailboxSignatures',
    component: () => import('../views/Customer/Accounts/MailSignatureManageView.vue'),
    meta: { requiresCustomer: true }
  },
  {
    path: '/subscriptions',
    redirect: '/mail/billing',
    meta: { requiresCustomer: true }
  },
  {
    path: '/subscriptions/success',
    redirect: '/mail/billing',
    meta: { requiresCustomer: true }
  },
  {
    path: '/subscriptions/canceled',
    redirect: '/mail/billing',
    meta: { requiresCustomer: true }
  },
  {
    path: '/super-admin',
    name: 'SuperAdminDashboard',
    component: () => import('../views/SuperAdmin/SuperAdminDashboardView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/subscriptions',
    name: 'SuperAdminSubscriptions',
    component: () => import('../views/SuperAdmin/SuperAdminSubscriptionsView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/subscriptions/new',
    name: 'SuperAdminSubscriptionCreate',
    component: () => import('../views/SuperAdmin/SuperAdminSubscriptionEditView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/subscriptions/:id/edit',
    name: 'SuperAdminSubscriptionEdit',
    component: () => import('../views/SuperAdmin/SuperAdminSubscriptionEditView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/catalog-health',
    name: 'SuperAdminCatalogHealth',
    component: () => import('../views/SuperAdmin/SuperAdminCatalogHealthView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/activity-logs',
    name: 'SuperAdminActivityLogs',
    component: () => import('../views/SuperAdmin/SuperAdminActivityLogsView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/ai-usage',
    name: 'SuperAdminAiUsage',
    component: () => import('../views/SuperAdmin/SuperAdminAiUsageView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/storage-usage',
    name: 'SuperAdminStorageUsage',
    component: () => import('../views/SuperAdmin/SuperAdminStorageUsageView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/payment-hub',
    name: 'SuperAdminPaymentHub',
    component: () => import('../views/SuperAdmin/Billing/PaymentHubView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/products',
    name: 'SuperAdminProducts',
    component: () => import('../views/SuperAdmin/Billing/ProductsIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/products/new',
    name: 'SuperAdminProductsNew',
    component: () => import('../views/SuperAdmin/Billing/ProductFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/products/:id/edit',
    name: 'SuperAdminProductsEdit',
    component: () => import('../views/SuperAdmin/Billing/ProductFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/products/:id',
    name: 'SuperAdminProductShow',
    component: () => import('../views/SuperAdmin/Billing/ProductShowView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/plans',
    name: 'SuperAdminPlans',
    component: () => import('../views/SuperAdmin/Billing/PlansIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/plans/new',
    name: 'SuperAdminPlansNew',
    component: () => import('../views/SuperAdmin/Billing/PlanFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/plans/:id/edit',
    name: 'SuperAdminPlansEdit',
    component: () => import('../views/SuperAdmin/Billing/PlanFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/plans/:id',
    name: 'SuperAdminPlanShow',
    component: () => import('../views/SuperAdmin/Billing/PlanShowView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/customers',
    name: 'SuperAdminCustomers',
    redirect: '/super-admin/companies',
  },
  {
    path: '/super-admin/companies',
    name: 'SuperAdminCompanies',
    component: () => import('../views/SuperAdmin/Companies/CompaniesIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/companies/new',
    name: 'SuperAdminCompaniesNew',
    component: () => import('../views/SuperAdmin/Companies/CompanyFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/companies/:id/edit',
    name: 'SuperAdminCompaniesEdit',
    component: () => import('../views/SuperAdmin/Companies/CompanyFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/staff',
    name: 'SuperAdminStaff',
    component: () => import('../views/SuperAdmin/Staff/StaffIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/staff/new',
    name: 'SuperAdminStaffNew',
    component: () => import('../views/SuperAdmin/Staff/StaffFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/staff/:id/edit',
    name: 'SuperAdminStaffEdit',
    component: () => import('../views/SuperAdmin/Staff/StaffFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/mailboxes',
    name: 'SuperAdminMailboxes',
    component: () => import('../views/SuperAdmin/Mailboxes/MailboxesIndexView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/mailboxes/new',
    name: 'SuperAdminMailboxesNew',
    component: () => import('../views/SuperAdmin/Mailboxes/MailboxFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/mailboxes/:id/edit',
    name: 'SuperAdminMailboxesEdit',
    component: () => import('../views/SuperAdmin/Mailboxes/MailboxFormView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/super-admin/organization-setup',
    name: 'SuperAdminOrganizationSetup',
    component: () => import('../views/SuperAdmin/SuperAdminOrganizationSetupView.vue'),
    meta: { requiresSuperAdmin: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/roles',
    name: 'Roles',
    component: () => import('../views/rbac/Roles.vue')
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import('../views/rbac/Permissions.vue')
  },
  {
    path: '/users/access',
    name: 'UserAccess',
    component: () => import('../views/rbac/UserAccess.vue')
  }
];

export default appRoutes;
